import React from 'react';
import ReactDOM from 'react-dom/client';
// The app typeface (Sandy 2026-07-27): DM Sans everywhere, self-hosted with
// font-display: swap rather than a Google Fonts <link>. These five weights are
// exactly what the app uses — 400 body, 500 medium, 600 semibold, 700 bold,
// 800 extrabold. Inter and Poppins were both retired in this change.
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/dm-sans/800.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './tailwind.css';

const rootElement = document.getElementById('root');

// StrictMode disabled for now: its dev-only double-invoke of effects fires the session `start`
// twice, which can create an orphan question row and a frontend/backend recordID mismatch.
ReactDOM.createRoot(rootElement).render(
  <App />
);

reportWebVitals();